import Polygon from "@arcgis/core/geometry/Polygon";
import { ZoneAPI } from "@ai360/core";

export class AgEventAreaPolygon implements ZoneAPI.IZonePolygon {
    public polygonGuid: string | null = null;

    constructor(public shape: Polygon | null) {}
}
